import React, { Component } from 'react'
import styled from 'styled-components'
import withStyles from '@material-ui/core/styles/withStyles'
import Helmet from 'react-helmet'
import LayoutContainer from '../components/LayoutContainer'
import Button from '../components/CustomButtons/Button'
import CustomInput from '../components/CustomInput/CustomInput'
import config from '../../data/SiteConfig'
import People from '@material-ui/icons/People'
import Mail from '@material-ui/icons/Mail'
import Grid from '@material-ui/core/Grid'
import { FaTelegramPlane } from 'react-icons/fa'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import Signup from '../components/Form/Signup'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import Card from '../components/Card/Card.jsx'
import CardHeader from '../components/Card/CardHeader.jsx'
import CardBody from '../components/Card/CardBody.jsx'
// @material-ui/icons
import Close from '@material-ui/icons/Close'
import javascriptStyles from '../assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx'

function Transition(props) {
  return <Slide direction="down" {...props} />
}

class ContactPage extends Component {
  state = { appointmentModal: false, appointmentSrc: '' }
  render() {
    const { classes, data } = this.props
    const pageEdges = data.page.edges[0]
    const pageData = pageEdges.node.frontmatter
    const settings = data.settings.edges[0].node.frontmatter
    // console.log(data)

    return (
      <LayoutContainer>
        <Helmet title={pageData.title} />
        <ContactContainer>
          <div>
            <h2>{pageData.title}</h2>
            <h5>
              <strong style={{ color: 'black' }}>{pageData.subtitle}</strong>
            </h5>
            <SectionContainer>
              <FlexContainer column>
                <LocationContainer>
                  {pageData.locations.map((location, i) => (
                    <div key={i}>
                      <h5>{location.title}</h5>
                      <p dangerouslySetInnerHTML={{ __html: location.body }} />
                      <Button
                        onClick={() =>
                          this.setState({
                            appointmentModal: true,
                            appointmentSrc: location.appointmentBooking,
                          })
                        }
                        size="sm"
                        color="primary"
                      >
                        Book Appointment
                      </Button>
                    </div>
                  ))}
                </LocationContainer>
                <FlexContainer xsWrap>
                  <OutboundLink href="https://support.bitnational.com">
                    <Button size="lg" color="primary" simple>
                      <People />
                      Support Desk
                    </Button>
                  </OutboundLink>
                  <Button
                    href="https://t.me/bitnational"
                    size="lg"
                    color="telegram"
                    simple
                  >
                    <FaTelegramPlane />
                    <span>
                      Join us on <strong>Telegram</strong>
                    </span>
                  </Button>
                </FlexContainer>
              </FlexContainer>
            </SectionContainer>
          </div>
          <NewsletterContainer>
            <h4>
              <strong>{settings.newsletter}</strong>
            </h4>
            <Signup />
          </NewsletterContainer>
        </ContactContainer>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal + ' ' + classes.modalLogin,
          }}
          open={this.state.appointmentModal}
          TransitionComponent={Transition}
          onClose={() => this.setState({ appointmentModal: false })}
        >
          <DialogTitle className={classes.modalHeader}>
            <CardHeader
              className={`${classes.textCenter} ${classes.cardLoginHeader}`}
              plain
              color="primary"
            >
              Book an Appointment
              <Button
                onClick={() => this.setState({ appointmentModal: false })}
                style={{ position: 'absolute', top: 0, right: 5 }}
                size="sm"
                justIcon
                color="info"
                simple
              >
                <Close />
              </Button>
            </CardHeader>
          </DialogTitle>
          <DialogContent className={classes.modalBody}>
            <CardBody className={classes.cardLoginBody} />
          </DialogContent>
          <iframe
            src={this.state.appointmentSrc}
            width="100%"
            height="100%"
            scrolling="yes"
            style={{ border: 0, borderRadius: '0 0 6px 6px' }}
          />
        </Dialog>
      </LayoutContainer>
    )
  }
}

const NewsletterContainer = styled.div`
  margin-top: ${p => p.theme.col()};
`

const FlexContainer = styled.div`
  display: flex;
  flex-direction: ${p => (p.column ? 'column' : 'row')};
  ${p =>
    p.xsWrap &&
    `
  @media screen and (max-width: 768px) {
   flex-wrap: wrap
  }
  `};
`

const ContactContainer = styled.div`
  padding: ${p => p.theme.col()} ${p => p.theme.col(4)};
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${p => p.theme.col(2)};

  @media screen and (max-width: 1400px) {
    padding: 100px ${p => p.theme.col(2)};
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    display: block;
  }
`

const SectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 ${p => p.theme.col()};

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding-bottom: 50px;
  }
`

const LocationContainer = styled.div`
  padding: ${p => p.theme.col()} 0;
  display: inline-grid;
  max-width: 650px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 50px 2rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 50px 0;
  }
`

export const ContactQuery = graphql`
  query ContactQuery {
    page: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "contact-page" } } }
    ) {
      edges {
        node {
          frontmatter {
            title
            subtitle
            locations {
              title
              body
              appointmentBooking
            }
          }
        }
      }
    }
    settings: allMarkdownRemark(
      filter: { frontmatter: { key: { eq: "general-settings" } } }
    ) {
      edges {
        node {
          frontmatter {
            newsletter
          }
        }
      }
    }
  }
`

export default withStyles(javascriptStyles)(ContactPage)



// WEBPACK FOOTER //
// ./src/pages/contact.jsx